<section class="saved-searches has-pos-rel flex-one">
  <br/>

  <div class="saved-search-list is-flex min-height">
    <app-saved-search *ngFor="let search of savedSearches; trackBy: SavedSearch.trackBy" [savedSearch]="search" [parentComponent]="SavedSearchLocationType.SAVED_SEARCHES"
    (onDeleteSavedSearchClick)="onDeleteSavedSearchClick.emit($event)" (onSavedSearchClick)="onSavedSearchClick.emit($event)"></app-saved-search>
  </div>

  <div class="tooltip-info" *ngIf="savedSearches.length">
    <i class="material-icons">info</i>
    <p translate="my-remax.saved-searches.tooltip-daily"></p>
  </div>

  <button (click)="saveChangesClicked()" class="btn btn-secondary btn-save-changes" *ngIf="savedSearches.length">Save Changes</button>
  <button (click)="onDeleteAllClick.emit()" class="btn btn-secondary btn-delete-all" *ngIf="savedSearches.length">Delete All</button>

  <ng-container>
    <!--<app-panel-message class="hide-on-tablet-up">-->
      <!--<p translate="my-remax.saved-searches.no-saved-searches"></p>-->
      <!--<br/>-->
      <!--<button (click)="onStartSearchClick.emit()" class="btn btn-secondary btn-save-changes" style="width: 75%;" translate="my-remax.saved-searches.start-search"></button>-->
    <!--</app-panel-message>-->
    <div *ngIf="!savedSearches.length" class="tooltip-info is-flex-column has-flex-align-center has-flex-content-center min-height">
      <i class="material-icons">info</i>
      <p translate="my-remax.saved-searches.no-saved-searches"></p>
    </div>
    <button (click)="onStartSearchClick.emit()" class="btn btn-secondary btn-save-changes" translate="my-remax.saved-searches.start-search"></button>
  </ng-container>
</section>
